export const MEASUREMENT_SYSTEM = {
  METRIC: 0,
  IMPERIAL: 1,
}

const INCHES_PER_FOOT = 12
const CM_PER_INCH = 2.54
const LBS_PER_KG = 2.2046226218

const roundTo = (value, decimals = 1) => {
  if (!Number.isFinite(value)) {
    return null
  }
  const factor = 10 ** decimals
  return Math.round(value * factor) / factor
}

export const cmToInches = (cm, decimals = 1) => {
  const numeric = Number(cm)
  if (!Number.isFinite(numeric)) {
    return null
  }
  return roundTo(numeric / CM_PER_INCH, decimals)
}

export const inchesToCm = (inches, decimals = 1) => {
  const numeric = Number(inches)
  if (!Number.isFinite(numeric)) {
    return null
  }
  return roundTo(numeric * CM_PER_INCH, decimals)
}

export const kgToLbs = (kg, decimals = 1) => {
  const numeric = Number(kg)
  if (!Number.isFinite(numeric)) {
    return null
  }
  return roundTo(numeric * LBS_PER_KG, decimals)
}

export const lbsToKg = (lbs, decimals = 1) => {
  const numeric = Number(lbs)
  if (!Number.isFinite(numeric)) {
    return null
  }
  return roundTo(numeric / LBS_PER_KG, decimals)
}

export const cmToFeetAndInches = (cm) => {
  const totalInches = cmToInches(cm, 1)
  if (totalInches === null) {
    return { feet: null, inches: null }
  }

  const feet = Math.floor(totalInches / INCHES_PER_FOOT)
  const inches = roundTo(totalInches - (feet * INCHES_PER_FOOT), 1)

  if (inches >= INCHES_PER_FOOT) {
    return { feet: feet + 1, inches: 0 }
  }

  return { feet, inches }
}

export const feetAndInchesToCm = (feet, inches, decimals = 1) => {
  const feetNumeric = Number(feet)
  const inchesNumeric = Number(inches)
  if (!Number.isFinite(feetNumeric) && !Number.isFinite(inchesNumeric)) {
    return null
  }
  const safeFeet = Number.isFinite(feetNumeric) ? Math.max(0, feetNumeric) : 0
  const safeInches = Number.isFinite(inchesNumeric) ? Math.max(0, inchesNumeric) : 0
  const totalInches = (safeFeet * INCHES_PER_FOOT) + safeInches
  return inchesToCm(totalInches, decimals)
}

export const formatWeightByMeasurementSystem = (weightKg, measurementSystem, decimals = 1) => {
  const numeric = Number(weightKg)
  if (!Number.isFinite(numeric)) {
    return { value: null, unit: 'kg' }
  }

  if (Number(measurementSystem) === MEASUREMENT_SYSTEM.IMPERIAL) {
    return { value: kgToLbs(numeric, decimals), unit: 'lbs' }
  }

  return { value: roundTo(numeric, decimals), unit: 'kg' }
}


